import { TourStatus as Status } from "@graphql/types";
import React, { FC } from "react";
import { Trans } from "@helpers/translate";
import { Alert } from "@components/ui/Alert";

interface TourStatusProps {
  status: Status;
}

export const TourStatus: FC<TourStatusProps> = ({ status }) => {
  const props = {
    className: "p-4 mb-10",
    centered: true,
    showIcon: false,
  };

  if (status === Status.InReview) {
    return (
      <Alert variant="warning" {...props}>
        <Trans id="tour.status.in_review">This tour is under review</Trans>
      </Alert>
    );
  }

  if (status === Status.Rejected) {
    return (
      <Alert variant="error" {...props}>
        <Trans id="tour.status.rejected">This tour has been rejected</Trans>
      </Alert>
    );
  }

  if (status === Status.Inactive) {
    return (
      <Alert variant="warning" {...props}>
        <Trans id="tour.status.inactive">This tour is inactive</Trans>
      </Alert>
    );
  }

  if (status === Status.Draft) {
    return (
      <Alert variant="info" {...props}>
        <Trans id="tour.status.draft">This tour is under construction</Trans>
      </Alert>
    );
  }

  return null;
};
